import router from 'next/router';
import { deviceWidth } from 'src/utils/deviceWidth';
import { NoItemInCart, NoItemInCartSection, NoItemInCartText } from '../../cart.styles';
import { ZeroCart } from 'src/assets/svgExports/ZeroCart';
import getCustomCtaText from 'src/utils/getCustomCtaText';
import { getRoute, PATH } from 'src/utils/routes';
import { useSSRSelector } from 'src/redux';
import { getThemeColor } from 'src/utils/getThemeColor';
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';
import { Button } from 'src/components/DesignSystem/AtomicComponents';
import { canDisablePlaceOrder } from 'src/utils/canDisablePlaceOrder';

const EmptyCartView = () => {
  const themeColor = getThemeColor();

  const { storeInfo, isWishlistItemPresentOnStore, wishlistFeatureActive } =
    useSSRSelector((state) => ({
      storeInfo: state.storeReducer.store,
      isWishlistItemPresentOnStore: state.wishlistReducer?.wishlistItemCount,
      wishlistFeatureActive: state.storeReducer?.store?.services?.wishlist_flag,
    }));

  const shopButtonClick = () => {
    if (canDisablePlaceOrder()) {
      return;
    }

    router.push(getRoute(PATH.PRODUCT, storeInfo?.store_info?.domain));
  };

  const addFromWishlistCtaClick = () => {
    router.push(getRoute(PATH.WISHLIST, storeInfo?.store_info?.domain));
  };

  return (
    <NoItemInCart>
      <NoItemInCartSection>
        <ZeroCart
          height={deviceWidth >= 767 ? 184.32 : 123}
          width={deviceWidth >= 767 ? 226.77 : 151}
        />
        <NoItemInCartText>
          Your cart is empty, Go ahead and add something to the cart
        </NoItemInCartText>
      </NoItemInCartSection>
      {isWishlistItemPresentOnStore && wishlistFeatureActive ? (
        <Button
          py="18px"
          mb="13px"
          width={IS_DESKTOP ? '252px' : '180px'}
          fontColor={themeColor}
          roundness={storeInfo?.theme?.roundness}
          backgroundColor="#ffffff"
          borderColor={themeColor}
          label={'Add from Wishlist'}
          variant="solid"
          fontSize={IS_DESKTOP ? '16px' : '15px'}
          onClick={addFromWishlistCtaClick}
        />
      ) : null}
      <Button
        width={IS_DESKTOP ? '252px' : '180px'}
        py="18px"
        fontColor="#ffffff"
        roundness={storeInfo?.theme?.roundness}
        backgroundColor={themeColor}
        label={getCustomCtaText('cart_cta')}
        variant="solid"
        fontSize={IS_DESKTOP ? '16px' : '15px'}
        onClick={shopButtonClick}
      />
    </NoItemInCart>
  );
};

export default EmptyCartView;
